import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import useScrollReveal from "../hooks/useScrollReveal";

const CTABanner = () => {
  const [ref, isVisible] = useScrollReveal(0.1);

  const scrollTo = () =>
    document.getElementById("products")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="py-20 px-4" data-testid="cta-section">
      <div className="max-w-5xl mx-auto">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, scale: 0.95 }}
          animate={isVisible ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="relative bg-gradient-to-br from-orange-500 via-red-500 to-orange-600 rounded-3xl p-12 sm:p-16 text-center overflow-hidden"
          data-testid="cta-banner"
        >
          {/* Decorative circles */}
          <div className="absolute -top-16 -right-16 w-64 h-64 bg-white/10 rounded-full pointer-events-none" />
          <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-yellow-400/20 rounded-full pointer-events-none" />
          <div className="absolute top-8 right-24 w-16 h-16 bg-white/10 rounded-full pointer-events-none" />

          {/* Floating product mini images */}
          <motion.div
            animate={{ y: [0, -12, 0], rotate: [0, 5, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            className="absolute top-6 left-8 w-20 opacity-25 pointer-events-none hidden sm:block"
          >
            <img
              src="/redchips.png"
              alt=""
              className="w-full mix-blend-luminosity"
            />
          </motion.div>
          <motion.div
            animate={{ y: [0, -10, 0], rotate: [0, -5, 0] }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 1 }}
            className="absolute bottom-6 right-8 w-20 opacity-25 pointer-events-none hidden sm:block"
          >
            <img
              src="/Salted-lkWK5iNw.png"
              alt=""
              className="w-full mix-blend-luminosity"
            />
          </motion.div>

          {/* Content */}
          <div className="relative z-10">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Sparkles size={18} className="text-yellow-300" />
              <span className="text-yellow-200 font-semibold text-sm uppercase tracking-wider">
                Fresh. Crispy. Delicious.
              </span>
              <Sparkles size={18} className="text-yellow-300" />
            </div>

            <h2 className="text-4xl sm:text-6xl font-black text-white mb-5 leading-tight">
              Ready to Munch?
            </h2>
            <p className="text-orange-100 text-lg sm:text-xl mb-10 max-w-lg mx-auto leading-relaxed">
              Explore our full range of authentic Indian snacks. Something
              delicious for every mood and moment!
            </p>

            <button
              onClick={scrollTo}
              className="inline-flex items-center gap-3 bg-white text-orange-600 rounded-full px-10 py-5 font-black text-lg shadow-2xl hover:scale-105 hover:shadow-orange-900/20 transition-all duration-200 group"
              data-testid="cta-explore-btn"
            >
              Explore All Products
              <ArrowRight
                size={22}
                className="group-hover:translate-x-1 transition-transform duration-200"
              />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABanner;
